import StopsDetails from './styled';

export default StopsDetails;
